wbApp.directive('wbSemesterCombo', ['$timeout', '$translate', '$filter', 'semesterSvc',
    function ($timeout, $translate, $filter, semesterSvc) {
        function formatResult(semester) {
            if (!semester) { return; }

            let dateFilter = $filter('date');

            if (semester.isMain) {
                return "<div class='row' style='width:400px'>" +
                           "<div class='col-md-7'><strong>" + semester.name + "</strong></div>" +
                           "<div class='col-md-5'><strong>" + dateFilter(semester.startDate, 'shortDate') + ' - ' + dateFilter(semester.endDate, 'shortDate') + "</strong></div>" +
                       "</div>";
            } else {
                return "<div class='row' style='width:400px'>" +
                           "<div class='col-md-7'>" + semester.name + "</div>" +
                           "<div class='col-md-5'>" + dateFilter(semester.startDate, 'shortDate') + ' - ' + dateFilter(semester.endDate, 'shortDate') + "</div>" +
                       "</div>";
            }
        }

        function formatSelection(semester) {
            return semester.name;
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                ngModel: '=',                
                showClearButton: '='
            },
            priority: 1,
            link: function (scope, elm, attrs, ctrl) {

                let semesters = semesterSvc.getAllActiveAsync();

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_SEMESTER'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: !!scope.showClearButton,
                        minimumResultsForSearch: 5,
                        data: semesters,
                        matcher: function (term, text, data) {
                            return data.name.toUpperCase().indexOf(term.toUpperCase()) >= 0;
                        }
                    });

                    ctrl.$render();
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return null;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        return value + "";
                    }
                });

                ctrl.$render = function () {
                    semesters.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                elm.on('change', function (e) {
                    scope.$apply(function () {
                        ctrl.$setViewValue(e.val);
                        semesterSvc.setDefault(e.val);
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });

            }
        }
    }]);